import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { Button, Form, Input, Row } from "antd";
import ButtonGroup from "antd/es/button/button-group";

import Swal from "sweetalert2";

import ApiService from "../../apis/ApiService_mall";
import { handleIsMallUserWithPartners } from "../../pages/user/LoginUitls";
import { setLoading } from "../../redux/store/common/commonDuck";

const mallApi = new ApiService();

const MallLoginComponent = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const isLoading = useSelector((state) => state.common.loading);
	const user = useSelector((state) => state.auth.user);
	const setIsLoading = (value) => dispatch(setLoading(value));

	useEffect(() => {
		if (!window.Kakao?.isInitialized()) {
			// 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
			window.Kakao?.init(process.env.REACT_APP_KAKAO_KEY);
		}
		naverLoginInit();
	}, []);

	/**
	 * 네이버 로그인 설정
	 */
	const naverLoginInit = () => {
		const naverLogin = new window.naver.LoginWithNaverId({
			clientId: "uRBnEup5L0wKh3Onbbtq",
			callbackUrl: `${process.env.REACT_APP_HOST}/user/sns/naver`,
			callbackHandle: true,
			isPopup: false, // 로그인 팝업여부
			loginButton: {
				color: "green", // 색상(white, green)
				type: 3, // 버튼타입(1,2,3)
				height: 60, // 배너 및 버튼 높이
			},
		});

		naverLogin?.init();
		naverLogin?.logout(); // 네이버 로그인이 계속 유지되는 경우가 있다. 초기화시 로그아웃
	};

	const kakaoLogin = async () => {
		if (window.Kakao) {
			if (user) {
				let param = {
					id: user.id,
					user_id: user.user_id,
				};
				await mallApi.leave(param);
			}
			window.Kakao.Auth.authorize({
				redirectUri: `${process.env.REACT_APP_HOST}/user/sns/kakao`,
				scope:
					"gender birthyear birthday profile_nickname phone_number talk_message friends",
			});
		}
	};

	const naverLogin = () => {
		let naverLoginButton = document.querySelector("#naverIdLogin").firstChild;
		naverLoginButton.click();
	};

	/**
	 * 일반 로그인 데이터
	 */
	const [userLogin, setUserLogin] = useState({
		phone: "",
		password: "",
	});

	/**
	 * 일반 로그인 정보 받기
	 * @param e
	 */
	const handleUserLogin = (e) => {
		let { name, value } = e.target;
		let phone = value?.replaceAll(/[^0-9]/g, "");
		if (name === "phone") {
			if (value?.length <= 11) {
				setUserLogin({
					...userLogin,
					[name]: phone,
				});
			}
		} else {
			setUserLogin({
				...userLogin,
				[name]: value,
			});
		}
	};

	/**
	 * 일반 로그인 버튼 클릭
	 */
	const submitUserLogin = async () => {
		setIsLoading(true);
		const param = {
			...userLogin,
		};

		let res = await mallApi.phoneLogin(param);
		if (res.data.code === 200) {
			const user = res.data.result.user;
			localStorage.removeItem("admin:accessToken");
			localStorage.removeItem("admin:refreshToken");
			localStorage.setItem(
				"admin:accessToken",
				res.data.result.tokenDto.accessToken
			);
			localStorage.setItem(
				"admin:refreshToken",
				res.data.result.tokenDto.refreshToken
			);
			setIsLoading(false);
			await handleIsMallUserWithPartners(user, dispatch, history);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: `${res.data.msg}`,
				confirmButtonText: "확인",
				// confirmButtonColor: "#212529",
			});
			setIsLoading(false);
		}
		setIsLoading(false);
	};

	return (
		<div className={`login-page-div mall-login-page-div`}>
			<div className={`login-div`} style={{ paddingBottom: "2em" }}>
				<p className={`login-title-normal`} style={{ textAlign: "center" }}>
					아이디와 비밀번호 입력없이 SNS로 <b>1초만에 로그인/회원가입</b>{" "}
					해보세요.
				</p>
				<ButtonGroup
					className={`sns-login-button-group`}
					style={{
						position: "relative",
						gap: "1em",
						padding: 0,
					}}
				>
					<Button
						className={`kakao-button`}
						onClick={kakaoLogin}
						loading={isLoading}
						style={{ fontSize: "1em", padding: "0.6em 1em" }}
					>
						<img
							src={`/assets/images/login/recent-login.png`}
							alt={`최근 로그인`}
							className={`recently-login-icon sns`}
						/>
						<img
							src={`/assets/images/login/kakao-login.png`}
							alt={`kakao-icon`}
						/>
						카카오 간편 로그인 / 회원가입
					</Button>
					<Button
						className={`naver-button`}
						onClick={() => {
							// onSaveBackPageSession();
							let naverLoginButton =
								document.querySelector("#naverIdLogin").firstChild;
							naverLoginButton.click();
						}}
						loading={isLoading}
						style={{ fontSize: "1em", padding: "0.6em 1em" }}
					>
						<img
							src={`/assets/images/login/recent-login.png`}
							alt={`최근 로그인`}
							className={`recently-login-icon sns`}
						/>
						<img
							src={`/assets/images/login/naver-login.png`}
							alt={`naver-icon`}
						/>
						네이버 간편 로그인 / 회원가입
					</Button>
					<div id="naverIdLogin" style={{ display: "none" }} />
				</ButtonGroup>
			</div>
			<div className={`login-div`}>
				<div className={`login-input-div`}>
					<p className={`login-title`}>휴대폰 번호</p>
					<Input
						type={"text"}
						placeholder={`휴대폰 번호`}
						pattern="\d*"
						name={"phone"}
						value={userLogin.phone}
						onChange={handleUserLogin}
						disabled={isLoading}
					/>
				</div>
				<div className={`login-input-div`}>
					<p className={`login-title`}>비밀번호</p>
					<Input
						type={"password"}
						placeholder={`비밀번호`}
						name={"password"}
						value={userLogin.password}
						onChange={handleUserLogin}
						onPressEnter={submitUserLogin}
						disabled={isLoading}
					/>
					<div className={`login-password-sub-div`}>
						<button onClick={() => history.push(`/user/find`)}>
							<p id={`forget-password`}>비밀번호를 잊으셨나요?</p>
						</button>
						{/*<p>아이디 저장</p>*/}
					</div>
				</div>
				<div style={{ display: "flex", flexDirection: "column" }}>
					<button
						className={`signup-user-phone-button`}
						onClick={() => {
							sessionStorage.removeItem("snsUserInfo");
							history.push(`/user/signup`);
						}}
					>
						휴대폰 번호로 회원가입
					</button>
					<Button
						className={`blue-login-button`}
						style={{
							fontSize: "1em",
							marginTop: "0.8em",
							marginBottom: "1.5em",
						}}
						onClick={submitUserLogin}
						loading={isLoading}
					>
						로그인
					</Button>
					<p className={`signup-login-footer-text`}>
						당영투게더 회원가입 시 당영몰과 연동되며{"\n"}
						당영몰 아이디로도 당영투게더에 로그인이 가능합니다.
					</p>
					<button
						style={{
							color: "#117ffa",
							marginTop: "2em",
						}}
						onClick={() => history.push(`/login/before`)}
					>
						기존 로그인으로 돌아가기
					</button>
				</div>
			</div>
		</div>
	);
};

export default MallLoginComponent;
